'use strict'
import superagentDefaults from 'superagent-defaults'

var superagent = superagentDefaults()

export default function () {
  var baseUrl = process.env.VUE_APP_NATIVEHASH_URL

  return {
    logMissing (lang, key) {
      var url = baseUrl + '/app-missing-trans'
      console.log(lang, key)

      return superagent
        .post(url)
        .send({ lang, key })
    }
  }
}
